import { render, staticRenderFns } from "./Monitor.vue?vue&type=template&id=08d86733&"
import script from "./Monitor.vue?vue&type=script&lang=ts&"
export * from "./Monitor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports